import classnames from 'classnames';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { useGetFundraisingStatus } from '@/query/queries/fundraising/useGetFundraisingStatus';
import { FundraisingCalculation } from '../../components/FundraisingCalculation';
import { ConfirmBlock } from '../ConfirmBlock';
import { VatWarning } from '../VatWarning';
import Icon from './icon_back.svg';
import s from './index.module.scss';
import { APP_LINKS } from '@/helpers/links.js';
import { MyLink } from '@/components/MyLink/index.jsx';

export const StepFlexibilitySelect = ({ manualTariffSet, disabled, onBack }) => {
  const { data: status } = useGetFundraisingStatus();
  const { values, setFieldValue } = useFormikContext();
  const { t } = useTranslation('fundraising');

  return (
    <div className={s.wrapper}>
      <div className={s.navigation}>
        <button type="button" onClick={onBack} className={s.btn_back}>
          <img src={Icon} alt="arrow" width={24} height={24} />
          {t('step_flexibility_select.back')}
        </button>
      </div>
      <div className={s.content}>
        <div className="container-inner">
          <div className={s.inner}>
            <div className={s.header}>
              <h2 className="f-h2 f-500">{t('step_flexibility_select.payment_flexibility')}</h2>
              <p className={classnames(s.desc, 'f-label')}>
                {t('step_flexibility_select.add_payment_flexibility')}.{' '}
                <MyLink href={APP_LINKS.loanTermsFlexibility()}>{t('step_fpg_select.learn_more')}</MyLink>
              </p>
            </div>
            <div>
              <div className={s.cards}>
                {status?.available_flexibility_options?.map(option => {
                  const isActive = option.id === values.flexibility_option?.id;

                  return (
                    <div
                      key={option.id}
                      className={classnames(s.card, isActive && 'active')}
                      onClick={() => setFieldValue('flexibility_option', option)}
                    >
                      <div className={s.card_top}>
                        <h3 className="f-h3 f-500">{option.title}</h3>
                        <div dangerouslySetInnerHTML={{ __html: option.description }} />
                      </div>
                      <div className={s.fee}>
                        <div className={s.fee_value}>
                          {Number(option.amount)
                            ? `${Number(option.amount)}%`
                            : t('step_flexibility_select.free')}
                        </div>
                        {!!Number(option.amount) && (
                          <div className={s.fee_desc}>
                            {t('step_flexibility_select.flexibility_fee')}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
              <VatWarning />
            </div>
            <FundraisingCalculation manualTariffSet={manualTariffSet} />
            <ConfirmBlock disabled={disabled} />
          </div>
        </div>
      </div>
    </div>
  );
};
